import { render, staticRenderFns } from "./112hddlgdyh.vue?vue&type=template&id=478478de&"
import script from "./112hddlgdyh.vue?vue&type=script&lang=js&"
export * from "./112hddlgdyh.vue?vue&type=script&lang=js&"
import style0 from "./112hddlgdyh.vue?vue&type=style&index=0&id=478478de&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports